import { createSlice } from "@reduxjs/toolkit";
import { resetOrganisationAction } from "../Action/OrganisationAction";

const initialState = {
  dashboard: {},
  staff: [],
  memberOrganisations: [],
};

const organisationSlice = createSlice({
  name: "organisation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetOrganisationAction, () => initialState);
  },
});

export default organisationSlice.reducer;
